import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { css, StyleSheet } from 'aphrodite';
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Form } from 'react-bootstrap';
import ToggleSwitch from 'react-switch';

import {
  auroMetalSaurus,
  coolGrey,
  grape,
  greyStroke,
  lightGreyNew,
  positiveGreen,
  positiveGreenBackground,
  softGreenLight,
  squidInk,
} from 'lib/css/colors';

function BrandVerifyHeader({ stats, canCleanupBrands, bookmarkedOnly, onBookmarkedOnlyChange }) {
  return (
    <div className={classNames(css(styles.container), 'd-flex align-items-center')}>
      <div className="d-flex align-items-center">
        <FontAwesomeIcon icon={faLayerGroup} className={css(styles.titleIcon)} />
        <h4 className={css(styles.title)}>Brand Verify</h4>
      </div>
      {canCleanupBrands && (
        <Form.Group
          className={classNames(css(styles.bookmarkToggle), 'd-flex flex-column align-items-start')}
        >
          <Form.Label className={css(styles.bookmarkLabel)}>Bookmarked only</Form.Label>
          <ToggleSwitch
            onColor={grape}
            checked={bookmarkedOnly}
            checkedIcon={false}
            uncheckedIcon={false}
            onChange={onBookmarkedOnlyChange}
          />
        </Form.Group>
      )}
      {stats ? (
        <>
          <div className={classNames(css(styles.runPill, styles.statsPillSpacing))}>
            <span className={css(styles.runStatItem)}>
              <span className={css(styles.runStatLabel)}>In your queue:</span>
              {stats.pending_for_current_user}
            </span>
            <span className={css(styles.dot)}>•</span>
            <span className={css(styles.runStatItem)}>
              <span className={css(styles.runStatLabel)}>Verified by you (today):</span>
              {stats.verified_by_current_user_today}
            </span>
            <span className={css(styles.dot)}>•</span>
            <span className={css(styles.runStatItem)}>
              <span className={css(styles.runStatLabel)}>Unverifiable by you (today):</span>
              {stats.unverifiable_by_current_user_today}
            </span>
            <span className={css(styles.dot)}>•</span>
            <span className={css(styles.runStatItem)}>
              <span className={css(styles.runStatLabel)}>Merged by you (today):</span>
              {stats.merged_by_current_user_today}
            </span>
          </div>
          <div className={css(styles.teamPill)}>
            <span className={css(styles.teamStatLabel)}>Pending for the team:</span>
            {stats.total_pending}
          </div>
        </>
      ) : null}
    </div>
  );
}

BrandVerifyHeader.propTypes = {
  stats: PropTypes.shape({
    total_pending: PropTypes.number,
    pending_for_current_user: PropTypes.number,
    verified_by_current_user_today: PropTypes.number,
    unverifiable_by_current_user_today: PropTypes.number,
    merged_by_current_user_today: PropTypes.number,
  }),
  canCleanupBrands: PropTypes.bool,
  bookmarkedOnly: PropTypes.bool,
  onBookmarkedOnlyChange: PropTypes.func,
};

const styles = StyleSheet.create({
  container: {
    paddingBottom: 12,
  },
  titleIcon: {
    color: squidInk,
    fontSize: '1.1rem',
    marginRight: 8,
  },
  title: {
    margin: 0,
    fontWeight: 700,
    color: squidInk,
  },
  subtitle: {
    color: auroMetalSaurus,
    fontSize: '0.85rem',
    marginTop: 4,
    marginLeft: 26,
  },
  runPill: {
    backgroundColor: positiveGreenBackground,
    border: `1px solid ${softGreenLight}`,
    borderRadius: 8,
    padding: '6px 14px',
    color: positiveGreen,
    fontSize: '0.8rem',
    fontWeight: 600,
  },
  teamPill: {
    marginLeft: 'auto',
    backgroundColor: lightGreyNew,
    border: `1px solid ${greyStroke}`,
    borderRadius: 8,
    padding: '6px 14px',
    color: coolGrey,
    fontSize: '0.8rem',
    fontWeight: 600,
  },
  teamStatLabel: {
    fontWeight: 700,
    marginRight: 8,
  },
  statsPillSpacing: {
    marginLeft: 16,
  },
  runStatLabel: {
    fontWeight: 700,
    marginRight: 8,
  },
  runStatItem: {
    color: positiveGreen,
  },
  dot: {
    margin: '0 6px',
    color: positiveGreen,
  },
  bookmarkToggle: {
    marginLeft: 16,
    marginBottom: 0,
  },
  bookmarkLabel: {
    marginBottom: 0,
    fontSize: '0.8rem',
    fontWeight: 600,
    color: squidInk,
    whiteSpace: 'nowrap',
  },
  runNextLink: {
    color: positiveGreen,
    fontWeight: 700,
    padding: 0,
    marginLeft: 4,
    textDecoration: 'underline',
    fontSize: '0.8rem',
    ':hover': {
      color: positiveGreen,
    },
  },
});

export default BrandVerifyHeader;
